<script setup>
import {reactive, onMounted, onUnmounted} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {activeComponentStore} from "@/Stores/ActiveComponentStore";
import {Permissions} from "@/Utils/Permissions";
import {ToastUtil} from "@/Utils/ToastUtil";

const compName = 'PayPeriodPersonReleasedComponent';

const props = defineProps({
  contextSchemaA: String,
  contextSchemaB: String,
  contextIdA: String,
  contextIdB: String
});

const data = reactive({
  defaultItem: {
    amount: null,
  },
  contextSchemaB: null,
  headers: [
    { title: 'Claim Number', key: 'claimnumber' },
    { title: 'Created Date', key: 'date' },
    { title: 'Type', key: 'status' },
    { title: 'Amount', key: 'amount' },
    { title: 'Description', key: 'description' },
    { title: 'Released Date', key: 'released_date' },
    { title: 'Created By', key: 'created_by' },
    { title: 'Actions', key: 'actions', sortable: false }
  ],
  items: [],
  isDisabled: false,
  loading: false,
  newItem: {
    amount: null,
  },
  openHoldbacksForm: false,
  search: null,
  valid: true
});

const formatISODateToAmerican = (date) => {
  if (!date) return null
  const [year, month, day] = date.split('-')
  return `${month}/${day}/${year}`
}

const getData = () => {
  data.loading = true
  let contextIdA = props.contextIdA;
  let contextIdB = props.contextIdB;
  let contextSchemaB = props.contextSchemaB;


  ApiWrapper.get(
          'holdbacks',
          'pay-period-person','payPeriodId=' +
          contextIdA +
          '&personId=' +
          contextIdB
      )
      .then((response) => {
        if(response.holdbacks){
          let temp = []
          for(let x in response.holdbacks){
            if(response.holdbacks[x].status === 'Released'){
              temp.push(response.holdbacks[x])
            }
          }
          data.items = temp
        }
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(()=>{
        data.loading = false
        data.isDisabled = false
      })
}

const unreleaseHoldback = (item) => {
  data.loading = true
  ApiWrapper.post('holdbacks', 'unrelease-holdback-from-pay-period', {
        holdbackId: item.id,
        payPeriodId: props.contextIdA
      })
      .then((response) => {
        getData()
        activeComponentStore.notifyComponents(['holdbacks'],compName);
        ToastUtil.successMsg('Unreleased holdback from pay period');
      })
      .catch((err) => {
        ToastUtil.error(err);
        data.loading = false;
      })
}

onMounted(()=>{
  activeComponentStore.registerComponent(
      compName,
      [
        'holdbacks'
      ],
      getData
  );
  getData()
})

onUnmounted(() => {
  activeComponentStore.deregisterComponent(compName);
});
</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Holdbacks Released To This Pay Period</v-toolbar-title>
        <v-progress-linear
            :active="data.loading"
            :indeterminate="data.loading"
            absolute
            bottom
            color="primary"
        ></v-progress-linear>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>

      <v-row>
        <v-col cols="6">
          <v-text-field
              v-model="data.search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              class="ml-4"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-data-table
          :items="data.items"
          :headers="data.headers"
          :search="data.search"
          loading-text="Loading... Please wait"
      >
        <template v-slot:[`item.claimnumber`]="{ item }">
          <RouterLink :to="`/claim/${item.claimid}`">
            {{ item.claimnumber }}
          </RouterLink>
        </template>
        <template v-slot:[`item.date`]="{ item }">
          {{ formatISODateToAmerican(item.date) }}
        </template>
        <template v-slot:[`item.amount`]="{ item }">
          {{ '$' + item.amount }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon class="mr-2" v-if="Permissions.checkPermissions(['holdbacks.unrelease'])" @click="unreleaseHoldback(item)">Unrelease</v-icon>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>
.container {
  padding: 5px;
}
[v-cloak] {
  display: none;
}
</style>